import { render, staticRenderFns } from "./CharmCall.vue?vue&type=template&id=711574da&scoped=true&"
import script from "./CharmCall.vue?vue&type=script&lang=js&"
export * from "./CharmCall.vue?vue&type=script&lang=js&"
import style0 from "./CharmCall.vue?vue&type=style&index=0&id=711574da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711574da",
  null
  
)

export default component.exports